// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #B8B8B8;
  margin-top: auto;
}

.footer-link {
  margin-left: 10px;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":[".footer {\n  height: 10vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: #B8B8B8;\n  margin-top: auto;\n}\n\n.footer-link {\n  margin-left: 10px;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
